import Vue from 'vue'
import directive from 'v-click-outside/src/v-click-outside'

Vue.directive('jclickoutside', directive)